import { render, staticRenderFns } from "./selectview.vue?vue&type=template&id=0435c8fb&scoped=true&"
import script from "./selectview.vue?vue&type=script&lang=js&"
export * from "./selectview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0435c8fb",
  null
  
)

export default component.exports